/**
 * @type utils
 * @name utils
 */
export { default as cls } from './classnames';
export * from './frame-throttle';
export * from './dom';
export * from './is';
export * from './type';
export * from './color';
export * from './browser';
export function handleUnit(value) {
    return typeof value === 'number' || !isNaN(Number(value)) ? value + "px" : value;
}
export function momentum(current, start, time, lowerMargin, wrapperSize, options) {
    if (options === void 0) { options = {}; }
    var distance = current - start;
    var speed = Math.abs(distance) / time;
    var _a = options.deceleration, deceleration = _a === void 0 ? 0.001 : _a, itemHeight = options.itemHeight, _b = options.swipeBounceTime, swipeBounceTime = _b === void 0 ? 2000 : _b, _c = options.bounceTime, bounceTime = _c === void 0 ? 700 : _c, _d = options.swipeTime, swipeTime = _d === void 0 ? 2500 : _d, wheel = options.wheel;
    var duration = swipeTime;
    var rate = wheel ? 4 : 15;
    var destination = current + (speed / deceleration) * (distance < 0 ? -1 : 1);
    if (wheel && itemHeight) {
        destination = Math.round(destination / itemHeight) * itemHeight;
    }
    if (destination < lowerMargin) {
        destination = wrapperSize ? lowerMargin - (wrapperSize / rate) * speed : lowerMargin;
        duration = swipeBounceTime - bounceTime;
    }
    else if (destination > 0) {
        destination = wrapperSize ? (wrapperSize / rate) * speed : 0;
        duration = swipeBounceTime - bounceTime;
    }
    return {
        destination: Math.round(destination),
        duration: duration,
    };
}
export function arrayTreeFilter(data, filterFn, options) {
    options = options || {};
    options.childrenKeyName = options.childrenKeyName || 'children';
    var children = data || [];
    var result = [];
    var level = 0;
    do {
        var foundItem = children.filter(function (item) { return filterFn(item, level); })[0];
        if (!foundItem) {
            break;
        }
        result.push(foundItem);
        children = foundItem[options.childrenKeyName] || [];
        level += 1;
    } while (children.length > 0);
    return result;
}
export function easeOutCubic(elapsed, initialValue, amountOfChange, duration) {
    var newElapsed = elapsed / duration - 1;
    return amountOfChange * (newElapsed * newElapsed * newElapsed + 1) + initialValue;
}
export function nextTick(func) {
    setTimeout(func, 20);
}
/** 模拟滑动阻尼效果，使用函数x = X/(aX+b)，x为元素位移，X为滑动距离，a,b为自定义参数通过设置两个目标对应关系求得
 * 例如目标X=500时x=100, X=200时x=60，可得a,b
 */
export function fingerDisToLabelDis(x, damping) {
    return damping ? x / (damping[0] * x + damping[1]) : x / (0.013312 * x + 1.636345);
}
